import React, { useEffect,useState,useRef } from "react";
import axios from 'axios'; 
import Swal from 'sweetalert2';
import { BASE_URL } from '../../App'
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import { Switch, Container, Button, TextField, Checkbox, Autocomplete, Tabs, Tab, Box, Stack, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { Backdrop, Skeleton ,CircularProgress } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import CRI from '../image/cri_logo.jpg'
import { number } from "prop-types";
import {  IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const NewServiceClaimInvoice = () => {
    const [showTable, setShowTable] = useState(true);
    const [showTable1, setShowTable1] = useState(false);
    const [tokennumber, settokennumber] = useState('');
    const [branchlist, setBranchlist] = useState([]);
  const [selectedbranch, setSelectedbranch] = useState([]);
  const [open, setOpen] = React.useState(false);
const branchcode = localStorage.getItem("BRANCH_CODE");

    const [formData, setFormData] = useState({
        fromAddress: "",
        claimedDate: "",
        invSerNo: "",
        gstNo: "",
        state: "",
        serviceType: "",
        scrNo: "",
        tollFreeNo: "",
        productSerialNo: "",
        customerName: "",
        productDescription: "",
        customerMobile: "",
        documentNo: "",
        documentDate: "",
        billNo: "",
        billDate: "",
        dealerName: "",
        serviceCenter: "",
        spareItems: [
            // {
            //     spareName: "Motor",
            //     hsnCode: "1234",
            //     quantity: 1,
            //     rate: 100,
            //     totalAmount: 100,
            // },
            // {
            //     spareName: "Wire",
            //     hsnCode: "5678",
            //     quantity: 2,
            //     rate: 50,
            //     totalAmount: 100,
            // },
        ],
        labourItems: [
            // {
            //     service: "Labour Charge",
            //     charge: 500,
            //     totalValue: 500,
            // },
        ],
        totalSpareAmount: "",
        totalLabourAmount: "",
        grandTotal: "",
    });


    const fetchData = async (docNo) => {
        setOpen(true);
        if(!docNo){
            setOpen(false);
            if (!docNo) {
                Swal.fire({
                    icon: "info",                 
                    text: "Please enter a document number!",
                });
                return;
            }
            
        }
        
        try {
            // Make sure to replace BASE_URL with your actual API base URL
            const response = await axios.post(BASE_URL + '/getduplicateinvoicecopy', { 
                tokenno: docNo 
            });
          

            const data = response.data;

            // Assuming you have the data in the response
            if (data && data.service_claim && data.service_claim.length > 0) {
                setShowTable(false);
                const serviceClaim = data.service_claim[0];
                const spares = data.spares_details.map(spare => ({
                    spareName: spare.spare_name,
                    hsnCode: spare.HSN_CODE,
                    quantity: parseFloat(spare.quantity),
                    rate: parseFloat(spare.rate),
                    totalAmount: parseFloat(spare.quantity)* parseFloat(spare.rate),
                }));

                const labourItems = data.labour_details.map(labour => ({
                    service: labour.labourcharge_description,
                    charge: parseFloat(labour.rate),
                    totalValue: parseFloat(labour.rate),
                }));

                const dealerAddress = data.dealer_details[0]?.NewFiled || "Not Available";

                setFormData(prevState => ({
                    ...prevState,
                    fromAddress: dealerAddress,
                    claimedDate: serviceClaim.createdon,
                    invSerNo: serviceClaim.serbill_no,
                    gstNo: data.cstnumber,  // Assuming GST number is the `asccode`
                    state: data.state,  // You can parse it from the address if needed
                    serviceType: serviceClaim.servicetype,
                    scrNo: serviceClaim.servicecall_no,
                    tollFreeNo: serviceClaim.tokenno,  // Static value, change as needed
                    productSerialNo: serviceClaim.serial_no,
                    customerName: serviceClaim.name,
                    productDescription: serviceClaim.mat_code,
                    customerMobile: serviceClaim.phoneno,
                    documentNo: serviceClaim.doc_no,
                    documentDate: serviceClaim.createdon,
                    billNo: serviceClaim.serbill_no,
                    billDate: serviceClaim.billdate,
                    dealerName: data.partyname,
                    serviceCenter: serviceClaim.ascode,
                    spareItems: spares,
                    labourItems: labourItems,
                    totalSpareAmount: spares.reduce((total, item) => total + item.totalAmount, 0),
                    totalLabourAmount: labourItems.reduce((total, item) => total + item.totalValue, 0),
                    grandTotal: spares.reduce((total, item) => total + item.totalAmount, 0) + labourItems.reduce((total, item) => total + item.totalValue, 0),
                }));

                setOpen(false)
                setShowTable1(true);
            }
        } catch (error) {
            Swal.fire({
                icon: "info",                 
                text: "No Data Found !",
            });
            setOpen(false);
            console.error("Error fetching data:", error);
        }
    };

  



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

  

    // const printPage = () => {
    //     const contentToPrint = document.getElementById("contentToPrint");
    //     const printButton = document.getElementById("printPageButton");
    
    //     // Hide the print button itself
    //     printButton.disabled = true;  // Disable the button
    //     printButton.style.visibility = "hidden";
    
    //     // Hide all elements except the content to print
    //     const otherContent = document.querySelectorAll('body > *:not(#contentToPrint)');
    //     otherContent.forEach((element) => {
    //         element.style.visibility = "hidden";
    //     });
    
    //     // Create a new iframe for printing
    //     const iframe = document.createElement("iframe");
    //     iframe.style.position = "absolute";
    //     iframe.style.width = "0px";
    //     iframe.style.height = "0px";
    //     iframe.style.border = "none";
    //     document.body.appendChild(iframe);
    
    //     // Get the iframe's document
    //     const iframeDocument = iframe.contentWindow.document;
    
    //     // Open the iframe's document
    //     iframeDocument.open();
    
    //     // Inject HTML structure into iframe
    //     iframeDocument.write(`
    //         <!DOCTYPE html>
    //         <html>
    //         <head>
    //             <title>Print</title>
    //             <style>
    //                 @page {
    //                     size: A4;
    //                     margin: 0;
    //                 }
    //                 body {
    //                     margin: 0;
    //                     padding: 0;
    //                     width: 100%;
    //                     height: "100%";
    //                     overflow: hidden;
    //                 }
    //                 #contentToPrint {
    //                     width: 100%;
    //                    height: "100%";
    //                     box-sizing: border-box; /* Ensure borders are included in dimensions */
    //                     overflow: hidden;
    //                     page-break-before: always;
    //                 }

      

    //                 /* Avoid scaling of content if you want to keep borders visible */
    //                 html, body {
    //                     width: 100%;
    //                     height: 100%;
    //                     transform: none; /* No scaling, keep actual size */
    //                 }
    //                 /* Ensure no overflow beyond the page */
    //                 * {
    //                     box-sizing: border-box;
    //                 }
    //                 #contentToPrint h3 {
    //                     background-color: blue !important;
    //                 }
    //                 /* Apply the border explicitly */
                    
    //                 /* Import external stylesheets */
    //                 ${Array.from(document.styleSheets)
    //                     .map(styleSheet => {
    //                         if (styleSheet.href) {
    //                             return `@import url(${styleSheet.href});`;
    //                         } else {
    //                             // Inline styles (internal styles)
    //                             return styleSheet.cssText;
    //                         }
    //                     })
    //                     .join('')}
    //             </style>
    //         </head>
    //         <body>
    //             ${contentToPrint.outerHTML}
    //         </body>
    //         </html>
    //     `);
    
    //     iframeDocument.close();
    
    //     // Print once iframe is loaded
    //     iframe.onload = () => {
    //         iframe.contentWindow.print();
    
    //         // Once printing is done, remove the iframe and restore visibility
    //         document.body.removeChild(iframe);
    
    //         // Restore other content visibility
    //         otherContent.forEach((element) => {
    //             element.style.visibility = "visible";
    //         });
    
    //         // Restore the print button visibility and re-enable it
    //         printButton.style.visibility = "visible";
    //         printButton.disabled = false; // Re-enable the print button
    //     };
    // };
    const contentToPrintRef = useRef();

    const printPage = () => {
        const content = contentToPrintRef.current;
      
        const printWindow = window.open('', '', 'height=1000,width=800');
        printWindow.document.write('<html><head><title>Print</title>');
        printWindow.document.write('<style>');
        printWindow.document.write(`
          @page {
            size: A4;  /* Set the page size to A4 */
            margin: 0;  /* Remove default margins */
          }
      
          /* General page styles */
          body {
            margin: 0px;
            padding: 20px; 
            display: flex;
            justify-content: center;
            align-items: flex-start;  /* Align content at the top */
            height:  100%;
            box-sizing: border-box;
            width: 100%;  /* Ensure full width is used */
             border: 3px solid black; 
          }
      
          /* Center the content and apply full borders */
          #contentToPrint {
            width: 80%;  /* Adjust width as per your requirement */
            max-width: 800px;  /* Optional, to limit content width */
            padding: 20px;
            border: 3px solid black;  /* Full border around the content */
            box-sizing: border-box;
            text-align: center;  /* Center the text */
            margin-top: 20px;  /* Space from the top of the page */
          }
      
          /* Ensure content fits within the page */
          html, body {
            transform: scale(1);  /* No scaling, so content fits naturally */
            transform-origin: top left;
            overflow: hidden;
          }
      
          /* Optional - Styling for specific content elements */
          h1 {
            font-size: 18px;
            margin-bottom: 10px;
          }
          p {
            font-size: 14px;
            margin-bottom: 10px;
          }

           h3 {
      background-color: #f0f0f0;  /* Light gray background color for h3 */
      padding: 10px;
      border-radius: 5px;  /* Optional: rounded corners */
    }
      
     #contentToPrint  h3 {
      background-color: #f0f0f0;  /* Light gray background color for h3 */
      padding: 10px;
      border-radius: 5px;  /* Optional: rounded corners */
    }

          /* Ensure content does not break awkwardly */
          #contentToPrint {
            page-break-before: always;
            page-break-inside: avoid;
          }
        `);
        printWindow.document.write('</style></head><body>');
        printWindow.document.write(content.innerHTML);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
      
        printWindow.print();
      };
      
    


      const handleBack = () => {
        setShowTable(true);
        setShowTable1(false);
    };



useEffect(() => {
    const fetchBranchData = async () => {


      try {
        const response = await axios.post(BASE_URL + '/fillduplicateinvoicBranch', { branchcode });
  
        if (response.status === 200) {
          setBranchlist(response.data.branchlist);
          console.log('Fetched branchlist:', response.data.branchlist); // Log the response directly here
          console.log('Fetched branchlist1:', branchlist);

        } else {
          Swal.fire({
            icon: 'warning',
            text: 'Unexpected response status. Please try again.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          text: 'Failed to fetch branch data. Please try again later.',
        });
      }
    };
  
    if (branchcode) {
      fetchBranchData();
    }
  }, [branchcode]);

  const branch_List = branchlist ? branchlist.map((type) => ({
    Value: type.values,
    Label: type.text ,
})) : [];


  const getOptionLabel = (option) => option.text;

  const handlebranchChange = (newValue) => {
    setSelectedbranch(newValue);  // Update selected branch

    



  };

  const handletokennumber = (event) => {

    const inputValue = event.target.value;
    settokennumber(inputValue);
    
    };

    const handlePriceList = () => {

        
       
      
       
            const docNo =tokennumber;
            fetchData(docNo);
      
       
    };

    return (
<div>
{showTable && ( 
            <>
        <div className="container mt-5" style={{ justifyContent: 'center' }}>

        <br />
      
        <div className='row'>
            <div className='col-md-6'>
            <SelectSearch
  id="branch"
  label="Branch"
  options={branch_List}  // Ensure branchlist contains the correct format
 // getOptionLabel={getOptionLabel}  // Optionally: define how each option is displayed
  value={selectedbranch}  // Controlled component - selected value
  onChange={handlebranchChange}  // When the selection changes, update selectedbranch
/>

            </div>

            <div className='col-md-6'>
                {/* <label >E-Code</label> */}
                <TextField
                                        label="Token / Doc No"
                                        fullWidth
                                        type="number"
                                        margin="normal"
                                        value={tokennumber}
                                        onChange={handletokennumber}
                                    />
  
            </div>
        </div>
        <br />
                <div className='row'>
                    <Button size="small" fullWidth variant="contained" onClick={handlePriceList} ><b>View</b></Button>
                </div>
        </div>
        </>
        )}

{showTable1 && ( 
            <>
              <IconButton onClick={handleBack} style={{ marginBottom: "10px" }}>
                        <ArrowBackIcon />
                    </IconButton>
        <div  > 
        <div 
        ref={contentToPrintRef}
        id="contentToPrint"
        style={{
          height: "100%",
          fontFamily: "Calibri",
          margin: "30px",
          boxSizing: "border-box",
          border: "3px solid #000", // Full border around the entire page content
          padding: "10px",
          width: "95%",
        }}
      >
        <center>
          
            <div className="form" align="left">
                {/* First Table (From Address and Logo) */}
                <table
                    border="1"
                    style={{
                        marginBottom: "20px",
                        borderCollapse: "collapse",
                        width: "100%",
                       // borderColor: "#000",
                    }}
                >

                    <tbody>
                        <tr>
                            <td >
                                <table  border="1"
                    >
                                    <tr>
                                    <td style={{ color: "#FF0000", border: "1px solid #000" }}>From </td>
                                    </tr>
                                    <tr>
                                    <td>
                                    <textarea
    name="fromAddress"
    value={formData.fromAddress}
    onChange={handleChange}
    rows="4"  // Only one row to make it appear as a textbox
    cols="40"  // Control the width (in characters, can be adjusted)
    style={{
        width: "100%",  // Make the textarea fill its container
        padding: "5px", // Padding to make it look more like a text box
        border: "1px solid #ccc",  // Add a light border to make it look like a textbox
        borderRadius: "4px",  // Optional: rounded corners for a modern look
        resize: "none",  // Prevent resizing, so it stays like a text box
        fontSize: "14px", // Adjust font size to match typical text box font size
    }}
/>
                                {/* <textarea
                                    name="fromAddress"
                                    value={formData.fromAddress}
                                    onChange={handleChange}
                                    rows="3"
                                    cols="30"
                                    style={{
                                        width: "100%",
                                     
                                        padding: "5px",
                                        borderColor:"white",
                                    }}
                                /> */}
                            </td>
                                    </tr>
                                </table>
                            </td>
                            <td align="right">
                                <table>
                                    <tr>
                                        <td >

                                        <img src={CRI} alt="CRI" style={{ height: "125px", width: "90px", marginRight: "20px" }} />


                                        </td>
                                    </tr>
                                </table>

                            </td>
                            
                        

                        </tr>
                        <tr>
                            <td></td>
                            <td style={{textAlign:"right" ,fontWeight:"bolder"}}>
                            ESTIMATION / COST OF SERVICE 
                            </td>
                        </tr>
                    </tbody>
                    {/* <tbody>
            <tr>
              <td style={{ color: "#FF0000", border: "1px solid #000" }}>From </td>
              <td>
                <textarea
                  name="fromAddress"
                  value={formData.fromAddress}
                  onChange={handleChange}
                  rows="3"
                  cols="30"
                  style={{
                    width: "100%",
                    border: "1px solid #000",
                    padding: "5px",
                  }}
                />
              </td>
              <td align="right">

              <img src="https://pumpsourceindia.com/wp-content/uploads/2017/09/CRI-Pumps-India-logo.png" alt="CRI" style={{ height: "69px", width: "218px" }} />

              </td>
            </tr>
          </tbody>  */}

                </table>

                {/* Second Table (Claim Details) */}
                <table
                    style={{
                        width: "100%",
                        // margin: "auto",
                        marginTop:"-10px",
                        borderCollapse: "collapse",
                        border: "1px solid #000000",
                    }}
                >
                    <tbody>
                        <tr>
                            <td style={{ border: "0px solid #000" }}></td>
                            <td style={{ border: "1px solid #000", textAlign: "right" }}>Claimed Date:</td>
                            <td style={{ border: "1px solid #000" }}>
                                <input
                                    type="text"
                                    name="claimedDate"
                                    value={formData.claimedDate}
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        border: "1px solid #000",
                                        padding: "5px",
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border: "0px solid #000", textAlign: "center", fontWeight: "bold" }}>TO</td>
                            <td style={{ border: "1px solid #000", textAlign: "right" }}>Invoice No. / Service No.:</td>
                            <td style={{ border: "1px solid #000" }}>
                                <input
                                    type="text"
                                    name="invSerNo"
                                    value={formData.invSerNo}
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        border: "1px solid #000",
                                        padding: "5px",
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border: "0px solid #000" }}></td>
                            <td style={{ border: "1px solid #000", textAlign: "right" }}>GST No.:</td>
                            <td style={{ border: "1px solid #000" }}>
                                <input
                                    type="text"
                                    name="gstNo"
                                    value={formData.gstNo}
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        border: "1px solid #000",
                                        padding: "5px",
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border: "0px solid #000" }}></td>
                            <td style={{ border: "1px solid #000", textAlign: "right" }}>State:</td>
                            <td style={{ border: "1px solid #000" }}>
                                <input
                                    type="text"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        border: "1px solid #000",
                                        padding: "5px",
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border: "0px solid #000" }}></td>
                            <td style={{ border: "1px solid #000", textAlign: "right" }}>Service Type:</td>
                            <td style={{ border: "1px solid #000" }}>
                                <input
                                    type="text"
                                    name="serviceType"
                                    value={formData.serviceType}
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        border: "1px solid #000",
                                        padding: "5px",
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border: "0px solid #000" }}></td>
                            <td style={{ border: "1px solid #000", textAlign: "right" ,color:"red" }}>SCR No. / Service Call Report No.:</td>
                            <td style={{ border: "1px solid #000" }}>
                                <input
                                    type="text"
                                    name="scrNo"
                                    value={formData.scrNo}
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        border: "1px solid #000",
                                        padding: "5px",
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border: "0px solid #000" }}></td>
                            <td style={{ border: "1px solid #000", textAlign: "right" ,color :"red" }}>Toll Free / Service Call Token No.:</td>
                            <td style={{ border: "1px solid #000" }}>
                                <input
                                    type="text"
                                    name="tollFreeNo"
                                    value={formData.tollFreeNo}
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        border: "1px solid #000",
                                        padding: "5px",
                                    }}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>


                <table
                    className="borco"
                    align="center"
                    cellPadding="0"
                    cellSpacing="0"
                    style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px", marginBottom: "10px" }}
                >
                    <tbody>
                        {/* Row 1 */}
                        <tr>
                            <td  align="left" style={{ color: "#FF0000", fontSize: "12px" ,width:"25%" }}>
                                Product Serial No
                            </td>
                            <td
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                    borderColor: "Black",
                                    borderWidth: "thin",
                                    width:"25%",
                                    // width: "279px",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.productSerialNo}</span>
                            </td>

                            <td align="left" style={{ fontSize: "12px", paddingLeft: "7px",width:"25%" }}>
                                Customer Name
                            </td>
                            <td
                                height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                    marginTop: "13px",
                                    borderColor: "Black",
                                    borderWidth: "thin",
                                    width:"25%",
                                }}
                            >
                                <span style={{ fontSize: "12px", marginLeft: "3px" }}>
                                    {formData.customerName}
                                </span>
                            </td>
                        </tr>

                        {/* Row 2 */}
                        <tr>
                            <td align="left" style={{ fontSize: "12px" ,width:"25%" }}>
                                Product Description
                            </td>
                            <td
                                height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                    borderColor: "Black",
                                    // borderTopColor: "White",
                                    // borderBottomColor: "White",
                                    borderWidth: "thin",
                                    width:"25%",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.productDescription}</span>
                            </td>

                            <td align="left" style={{ fontSize: "12px", paddingLeft: "7px",width:"25%" }}>
                                Customer Mobile No
                            </td>
                            <td
                                 height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                 //   marginTop: "13px",
                                    borderColor: "Black",
                                    // borderTopColor: "White",
                                    borderWidth: "thin",
                                    width:"25%",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.customerMobile}</span>
                            </td>
                        </tr>

                        {/* Row 3 */}
                        <tr>
                            <td align="left" style={{ fontSize: "12px",width:"25%" }}>
                                Document No
                            </td>
                            <td
                                height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                    borderColor: "Black",
                                    borderTopColor: "Black",
                                    // borderBottomColor: "White",
                                    borderWidth: "thin",
                                    width:"25%",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.documentNo}</span>
                            </td>

                            <td align="left" style={{ fontSize: "12px", paddingLeft: "7px",width:"25%" }}>
                                Document Date
                            </td>
                            <td
                               height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                  //  marginTop: "13px",
                                    borderColor: "Black",
                                    // borderTopColor: "White",
                                    borderWidth: "thin",
                                    width:"25%",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.documentDate}</span>
                            </td>
                        </tr>

                        {/* Row 4 */}
                        <tr>
                            <td align="left" style={{ fontSize: "12px",width:"25%" }}>
                                Bill No
                            </td>
                            <td
                               height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                    borderColor: "Black",
                                    borderTopColor: "Black",
                                    // borderBottomColor: "White",
                                    borderWidth: "thin",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.billNo}</span>
                            </td>

                            <td align="left" style={{ fontSize: "12px", paddingLeft: "7px",width:"25%", }}>
                                Bill Date
                            </td>
                            <td
                                 height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                   // marginTop: "13px",
                                    borderColor: "Black",
                                    // borderTopColor: "White",
                                    borderWidth: "thin",
                                    width:"25%",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.billDate}</span>
                            </td>
                        </tr>

                        {/* Row 5 */}
                        <tr>
                            <td align="left" style={{ fontSize: "12px",width:"25%" }}>
                                Dealer Name
                            </td>
                            <td
                               height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                    borderColor: "Black",
                                    borderTopColor: "Black",
                                    borderWidth: "thin",
                                    width:"25%",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.dealerName}</span>
                            </td>

                            <td align="left" style={{ fontSize: "12px", paddingLeft: "7px",width:"25%" }}>
                                Service Center
                            </td>
                            <td
                                height="25"
                                align="left"
                                style={{
                                    borderStyle: "solid",
                                    //marginTop: "13px",
                                    borderColor: "Black",
                                    // borderTopColor: "White",
                                    borderWidth: "thin",
                                    width:"25%",
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{formData.serviceCenter}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Material Replaced Table */}
                <h3 style={{ textAlign: "center", backgroundColor: "blue", color: "white" }}>(A) Details of Material Replaced (Spares & Winding Wire)</h3>
                <table
                    style={{
                        width: "100%",
                        // margin: "auto",
                        marginTop: "-10px",
                        borderCollapse: "collapse",
                        border: "1px solid #000000",
                    }}
                >
                    <thead>
                        <tr>
                            <th style={{ border: "1px solid #000" }}>SL No.</th>
                            <th style={{ border: "1px solid #000" }}>Material Replaced</th>
                            <th style={{ border: "1px solid #000" }}>HSN Code</th>
                            <th style={{ border: "1px solid #000" }}>QTY</th>
                            <th style={{ border: "1px solid #000" }}>Price</th>
                            <th style={{ border: "1px solid #000" }}>Total Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formData.spareItems.length > 0 ? (
                            formData.spareItems.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: "1px solid #000" }}>{index + 1}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.spareName}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.hsnCode}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.quantity}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.rate}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.totalAmount}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center", border: "1px solid #000" }}>
                                    No spare items found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <table
                    style={{
                        width: "100%",
                        // margin: "auto",
                        borderCollapse: "collapse",
                        border: "1px solid #000000",
                    }}
                >
                    <tbody>
                        <tr>
                            <td style={{ border: "1px solid #000",width:"80%",textAlign:"right"}}>Total Spares Value (in Rs.)</td>
                            <td style={{ border: "1px solid #000" }}>{formData.totalSpareAmount}</td>
                        </tr>
                    </tbody>
                </table>
<br />
                {/* Labour Charges Table */}
                <h3 style={{ textAlign: "center", backgroundColor: "blue", color: "white" }}>(B) Labour Charges / Other Charges</h3>
                <table
                    style={{
                        width: "100%",
                        marginTop: "-10px",
                        borderCollapse: "collapse",
                        border: "1px solid #000000",
                    }}
                >
                    <thead>
                        <tr>
                            <th style={{ border: "1px solid #000" }}>Sl No.</th>
                            <th style={{ border: "1px solid #000" }}>Services</th>
                            <th style={{ border: "1px solid #000" }}>Charges</th>
                            <th style={{ border: "1px solid #000" }}>Total Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formData.labourItems.length > 0 ? (
                            formData.labourItems.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: "1px solid #000" }}>{index + 1}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.service}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.charge}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.totalValue}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", border: "1px solid #000" }}>
                                    No labour items found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Summary Table */}
                {/* <h3 style ={{textAlign:"center",backgroundColor:"blue",color:"white"}}>Summary</h3> */}
                <table
                    style={{
                        width: "100%",
                        // margin: "auto",
                        borderCollapse: "collapse",
                        border: "1px solid #000000",
                    }}
                >
                    <tbody>
                      
                        <tr>
                            <td style={{ border: "1px solid #000",width:"80%",textAlign:"right" }}>Total Labour Value (in Rs.)</td>
                            <td style={{ border: "1px solid #000" }}>{formData.totalLabourAmount}</td>
                        </tr>
                        <tr>
                            <td style={{ border: "1px solid #000",width:"80%",textAlign:"right" }}>(A+B)Grand Total (in Rs.)</td>
                            <td style={{ border: "1px solid #000" }}>{formData.grandTotal}</td>
                        </tr>
                    </tbody>
                </table>
                <div>
  <p style={{ color: 'red', marginBottom: '5px' }}>Note :</p>
  <p style={{ color: 'black', marginBottom: '5px', lineHeight: '1.2' }}>
    1. If GST is applicable, GST should be included in the Invoice.
  </p>
  <p style={{ color: 'black', marginBottom: '5px', lineHeight: '1.2' }}>
    2. If non-filing of Returns / GST is not paid, else GST is not reflected in our GSTR-2B return,
    the GST amount will be debited to the respective service provider and will be collected.
  </p>
</div>

    <table style={{ width: '100%', height:'30px',  border: "1px solid #000000", }} cellSpacing="0" cellPadding="0" align="center" className="table1">
      <thead>
        <tr>
          <td
            colSpan="4"
            align="center"
            style={{
              backgroundColor: '#00CCFF',
              color: '#FF0000',
              borderBottom: 'thin solid black',
            }}
          >
            ENCLOSURE DETAILS ( Please &#10003; appropriate Box )
          </td>
        </tr>
      </thead>
      <tbody>
        <tr align="center">
          <td style={{ width: '172px', height: '30px', textAlign: 'center' }}>
            <input id="wc" name="Warranty Coupon" type="checkbox" disabled />
            <span className="style3">Warranty Coupon</span>
          </td>
          <td style={{ width: '161px' }}>
            <input id="ws" name="Winding Slip" type="checkbox" disabled />
            <span className="style3">Winding Slip</span>
          </td>
          <td style={{ width: '190px', textAlign: 'center' }}>
            <input id="cbc" name="Warranty Coupon2" type="checkbox" disabled />
            <span className="style3">Customer Bill Copy</span>
          </td>
          <td style={{ width: '365px' }}>
            <input id="pwnp" name="Warranty Coupon3" type="checkbox" disabled />
            <span className="style3">Photo of the Pumpset with Newspaper of the day</span>
          </td>
        </tr>
      </tbody>
    </table>
   
                {/* Print Button */}
              
            </div>
            </center>
            </div>
            <div align="center"> 
        {/* <button size="small" fullWidth variant="contained"  endIcon={<PrintIcon style={{ fontSize: 30 }} />} 
                    id="printPageButton"
                    onClick={printPage}
                   
                >  Print Page
                </button>  */}
                <Button size="small"  variant="contained" onClick={printPage} endIcon={<PrintIcon />}  ><b> Print</b></Button>
                </div>
            
                  
        </div>
        </>
        )}
         <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
    
        </div>
    );
};

export default NewServiceClaimInvoice;
